import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlConsultaRemuneracao = '/service/contabilidade/remuneracaoRestService/'

class ConsultaRemuneracaoService extends BaseService {
    constructor() {
        super(NOME_TOKEN_ACESSO_DIRETO)
    }

    consultar(filtro) {
        let data = {
            referencia: filtro.referencia ? moment(filtro.referencia.value).format() : '',
            orgao: filtro.orgao ? filtro.orgao.map(e => e.value).join() : '',
            cargo: filtro.cargo ? filtro.cargo.map(e => e.value).join() : '',
            vinculo: filtro.vinculo ? filtro.vinculo.map(e => e.value).join() : '',
            funcionario: filtro.funcionario,
            setor: filtro.setor ? filtro.setor.map(e => e.value).join() : '',
            ativo: filtro.ativo ? filtro.ativo.value : '',
            matricula: '',
        }

        return this.conex.post(urlConsultaRemuneracao + 'recuperarConsultaRemuneracao/', JSON.stringify(data))
    }
}

export default ConsultaRemuneracaoService
